import { useLingui } from "@lingui/react";

import { isMessageDescriptor } from "@app/common/utils";

const useTranslateList = <T extends {}, K extends {}>(items: T[]) => {
  const { _ } = useLingui();

  const translatedItems = items.map((item) => {
    const translatedObject = Object.entries(item).reduce(
      (obj, [key, value]) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore-next-line
        obj[key] = isMessageDescriptor(value) ? _(value) : value;
        return obj;
      },
      {} as T
    );

    return translatedObject;
  });

  return translatedItems as unknown as K[];
};

export default useTranslateList;
